export default __webpack_public_path__ + "static/media/Woman_nursing_baby.6a2385b9.jpg";